module.exports = __webpack_public_path__ + "static/media/menu-adders-blue.4d1300ea.svg";